import React from 'react';
import BigNumber from 'bignumber.js';
import { DsTooltip } from '@tokenyico/design-system/dist/reactJS';
import { displayCurrency } from 'app/helpers/currency';

export const TotalPayment = (props) => {
  const { payments, currency, column, isMono } = props;
  const sum = new BigNumber(payments.investment ?? '0').plus(payments.fee ?? '0').toString();
  return +sum ? (
    <div className="total-payment">
      {!isMono ? (
        <DsTooltip
          text="" // for now, empty text is required to show html tooltip content. Remove it after fix.
          isVisibleOnHover
          hasHtmlContent
          theme="light"
          size="xs"
        >
          <div slot="htmlContent">
            {Object.entries(payments).map(([key, value]) =>
              !column || key !== 'fee' || value ? (
                <div key={key} className="total-payment__tooltip">
                  <div className="total-payment__tooltip--investment">
                    {key[0].toUpperCase() + key.slice(1)}
                  </div>
                  <div className="total-payment__tooltip--fee">
                    {displayCurrency(value, currency) ?? 0}
                  </div>
                </div>
              ) : null,
            )}
          </div>
          <span className="total-payment__badge">{displayCurrency(sum, currency)}</span>
        </DsTooltip>
      ) : (
        <span style={{ fontFamily: isMono ? 'var(--code-font-family)' : 'inherit' }}>
          {displayCurrency(sum, currency)}
        </span>
      )}
    </div>
  ) : (
    '-'
  );
};

// Order details layout
export const Section = ({ children }) => {
  return <div className="order-details__section">{children}</div>;
};

export const Item = ({ name, value, isMono = true }) => {
  return (
    <div className="order-details__section__item">
      <div className="order-details__section__item--key">{name}</div>
      <div className="order-details__section__item--value">
        {isMono ? <code>{value}</code> : value}
      </div>
    </div>
  );
};
